

import { Users, Car, Globe, Shield, Zap, Award, CheckCircle } from 'lucide-react';
import { getLanguage } from '@/utils/languageUtils';
import svCommon from '@/i18n/locales/sv/common.json';
import enCommon from '@/i18n/locales/en/common.json';

export interface FeatureData {
  iconName: string;
  title: string;
  description: string;
  color: string;
}

export const getFeaturesData = (lang?: 'sv' | 'en'): FeatureData[] => {
  const language = lang || getLanguage();
  const common = language === 'en' ? enCommon : svCommon;
  const featuresData_i18n = common.menuPages?.howItWorks?.overviewSection?.features || [];
  
  const iconNames = ['Car', 'CheckCircle', 'Shield', 'Zap', 'Award', 'Globe'];
  const colors = [
    "from-blue-100 to-blue-50",
    "from-yellow-100 to-yellow-50",
    "from-purple-100 to-purple-50",
    "from-yellow-100 to-yellow-50",
    "from-red-100 to-red-50",
    "from-cyan-100 to-cyan-50"
  ];

  return featuresData_i18n.map((feature: any, index: number) => ({
    iconName: iconNames[index] || iconNames[0],
    title: feature.title || "",
    description: feature.description || "",
    color: colors[index] || colors[0]
  }));
};

// Export function instead of computed value to allow dynamic language updates
// The component should call getFeaturesData() with useMemo based on language
export const featuresData: FeatureData[] = getFeaturesData();

export const iconComponents = {
  Car,
  Users,
  Globe,
  Shield,
  Zap,
  Award,
  CheckCircle
};

